
import { createSlice } from '@reduxjs/toolkit'

import { planningUnassignedTablesAdapter } from '../adapters/planningUnassignedTablesAdapter'

export const initialPlanningUnassignedTableState = planningUnassignedTablesAdapter.getInitialState()

export const planningUnassignedTablesSlice = createSlice({
  name: 'planningUnassignedTables',
  initialState: initialPlanningUnassignedTableState,
  reducers: {
    upsertMultiplePlanningUnassignedTables: (state, action) => {
      planningUnassignedTablesAdapter.upsertMany(state, action.payload)
    },
    upsertOnePlanningUnassignedTable: (state, action) => {
      planningUnassignedTablesAdapter.upsertOne(state, action.payload)
    },
    setPlanningUnassignedTableLoading: (state, action) => {
      const { id, isLoading } = action.payload
      const existingUnassignedTable = state.entities[id]
      
      if (existingUnassignedTable) {
        existingUnassignedTable.isLoading = isLoading
      }
    },
  },
})

export const { upsertMultiplePlanningUnassignedTables, upsertOnePlanningUnassignedTable, setPlanningUnassignedTableLoading } = planningUnassignedTablesSlice.actions
